import type { ThemeOptions } from '@mui/material/styles';
import { APP_FONT_FAMILY } from './fonts';

export { APP_TEXT_COLOR } from './colors';

/**
 * Readex Pro + Noto Sans multi-script stack, with MUI's default type scale
 * (14px theme base).
 */
export const appTypography: ThemeOptions['typography'] = {
  fontFamily: APP_FONT_FAMILY,
  h1: { fontWeight: 700 },
  h2: { fontWeight: 700 },
  h3: { fontWeight: 600 },
  h4: { fontWeight: 600 },
  h5: { fontWeight: 600 },
  h6: { fontWeight: 600 },
};

export const appTypographyComponents: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontFamily: APP_FONT_FAMILY,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
      },
    },
  },
};
